export class ExecucaoHistorico {
    id: number;
    usuario: String;
    dataInicioProcessamento: String;
    dataFimProcessamento: String;
    status: String;
    errorMessage: String;
    parameters: ExecucaoHistoricoParameters;
}

export class ExecucaoHistoricoParameters {
    carteira: String;
    grupoCarteira: string;
    regra: String;
    status: string;
    dataInicio: string;
    dataFim: string;
}

export class ExecutarHistorico {
    carteiraId: number;
    grupoCarteiraId: number;
    regraId: number;
    dataInicio: string;
    dataFim: string;
    status: String;
}
